import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim()
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim()

if (!supabaseUrl) {
  throw new Error('Missing VITE_SUPABASE_URL environment variable')
}

if (!supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_ANON_KEY environment variable')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Types for our database
export type FormType = 'loan_application' | 'deposit_application' | 'card_application' | 'remote_customer'
export type LoanType = 'ihtiyac_kredisi' | 'konut_kredisi' | 'tasit_kredisi' | 'kobi_kredisi'
export type DepositType = 'tl_mevduat' | 'usd_mevduat' | 'eur_mevduat'
export type ApplicationStatus = 'pending' | 'processing' | 'approved' | 'rejected' | 'completed'

export interface FormSubmission {
  id?: string
  form_type: FormType
  source_page: string
  source_section?: string
  user_agent?: string
  ip_address?: string
  referrer?: string
  created_at?: string
  updated_at?: string
}

export interface LoanApplication {
  id?: string
  submission_id?: string
  loan_type: LoanType
  amount: number
  term_months: number
  phone_number: string
  selected_banks?: string[]
  kvkk_consent: boolean
  marketing_consent: boolean
  status?: ApplicationStatus
  notes?: string
  created_at?: string
  updated_at?: string
}

export interface DepositApplication {
  id?: string
  submission_id?: string
  deposit_type: DepositType
  amount: string
  term_days: number
  phone_number: string
  selected_banks?: string[]
  kvkk_consent: boolean
  marketing_consent: boolean
  status?: ApplicationStatus
  notes?: string
  created_at?: string
  updated_at?: string
}

export interface CardApplication {
  id?: string
  submission_id?: string
  card_name?: string
  bank_name?: string
  phone_number: string
  email?: string
  kvkk_consent: boolean
  marketing_consent: boolean
  status?: ApplicationStatus
  notes?: string
  created_at?: string
  updated_at?: string
}

export interface RemoteCustomerApplication {
  id?: string
  submission_id?: string
  bank_name: string
  phone_number: string
  application_method?: string
  kvkk_consent: boolean
  marketing_consent: boolean
  status?: ApplicationStatus
  notes?: string
  created_at?: string
  updated_at?: string
}

// Public functions for client-side page retrieval
export const getPublicPage = async (slug: string) => {
  try {
    const { data, error } = await supabase
      .from('pages')
      .select('*')
      .eq('slug', slug)
      .eq('is_published', true)
      .single();

    if (error) {
      console.error('Error fetching page:', error);
      return null;
    }

    return data;
  } catch (error) {
    console.error('Error in getPublicPage:', error);
    return null;
  }
};

export const getAllPublicPages = async () => {
  try {
    const { data, error } = await supabase
      .from('pages')
      .select('*')
      .eq('is_published', true)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching pages:', error);
      return [];
    }

    return data || [];
  } catch (error) {
    console.error('Error in getAllPublicPages:', error);
    return [];
  }
};